export const withRetry = async (fn: Function, maxAttempts: number, debug: boolean = false) => {
    let attempts = 0;

    while (attempts < maxAttempts) {
        try {
            await fn();
            if (debug) console.log("Function executed successfully.");
            return;
        } catch (error) {
            attempts++;
            if (debug) console.error(`Attempt ${attempts} failed.`, error);

            if (attempts >= maxAttempts) {
                if (debug) console.error("Max attempts reached. Unable to complete the function.");
                throw error;
            }

            if (debug) console.log("Retrying...");
        }
    }
};
